import React, {Component} from 'react';
import {connect} from 'react-redux';
import config from "../../config";
import {BreadCumb, DataTables, NavBar} from "../../components";
import {ApiClient} from "../../libs/apiClient";
import {DISPATCH_ID, SERVICE_RESPONSE} from '../../libs/utils/Const';
import moment from "moment";
import $ from "jquery";


let apiClient = ApiClient.getInstance();
const headersDataTable = [
    {title: "Fecha", value: true},
    {title: "Proveedor", value: true},
    {title: "Nombre", value: true},
    {title: "Comentarios", value: true},
    {title: "Documento", value: true},
    {title: "Estatus", value: true},
    {title: "Hora", value: true},
];
class MiddlewareView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            updateData: false,
            headers: headersDataTable,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'))
        }

    }

    componentDidMount = async () =>{
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liMiddleware");

        let middlewareResponse = await apiClient.validateMiddleware();
        let today = moment(new Date()).format('YYYYMMDD');
        let date = {
            dateInit: today,
            dateFinal: today,
        }
        await this.callDocumentsListService(date);

        if(middlewareResponse.status === SERVICE_RESPONSE.ERROR){
            document.getElementById("btnDetener").style.setProperty("opacity",".2");
            document.getElementById("btnIniciar").style.setProperty("opacity","1");
            return;
        }
        if(document.getElementById("btnIniciar")){
            document.getElementById("btnIniciar").style.setProperty("opacity",".2");
            document.getElementById("btnDetener").style.setProperty("opacity","1");
        }

       
        

    }

    start = async () =>{
        let middlewareResponse = await apiClient.Middleware(1);

        if(middlewareResponse.status === SERVICE_RESPONSE.ERROR){
            return;
        };
        document.getElementById("btnIniciar").style.setProperty("opacity",".2");
        document.getElementById("btnDetener").style.setProperty("opacity","1");
    }

    stop = async () => {
        let middlewareResponse = await apiClient.Middleware(0);

        if(middlewareResponse.status === SERVICE_RESPONSE.ERROR){
            return;
        };
        document.getElementById("btnDetener").style.setProperty("opacity",".2");
        document.getElementById("btnIniciar").style.setProperty("opacity","1");
    }


    selectData = (event, option) => {
        if (option == 1) {
            this.setState({
                dateInit: moment(document.getElementById("fechaInicio").value).format('YYYYMMDD')
            })
        }
        if (option == 2) {
            this.setState({
                dateFinal: moment(document.getElementById("fechaFin").value).format('YYYYMMDD')
            })
        }
    };

    callDocumentsListService = async newDate => {
        const {notificationReducer: {showAlert}, enableSpinner} = this.props;
        let docStatus = $('#selectDocTypeDocumentSearchOMDL').val();
        let data = {
            dateInit: newDate.dateInit,
            dateFinal: newDate.dateFinal,
            switch1 : docStatus || '---',
            table: "OMDL",
        };
        
        enableSpinner(true);
        let middlewareListResponse = await apiClient.getDocumentsList(data);
        enableSpinner(false);

        if (middlewareListResponse.status === SERVICE_RESPONSE.SUCCESS) {

            if (!Array.isArray(middlewareListResponse.data)) {
                showAlert({type: 'error', message: 'Ocurrió un error al consultar la Información'});
                await this.setState({
                    data: [],
                });
                return;
            }

            if (middlewareListResponse.data.length === 0) {
                showAlert({type: 'info', message: 'No hay Información por mostrar'});
                await this.setState({
                    data: [],
                });
                return;
            }

            this.setState({
                data: middlewareListResponse.data,
            });
            return;
        }


    }

    
    render() {
        const {headers, data, updateData ,_user} = this.state;
        
        return (
            <div className="content-fluid">
                <NavBar props={this.props} _user={_user}/>
                <BreadCumb subitem1={'MIDDLEWARE'} url1={'#'}/>

                <div className="content" style={{marginLeft: "3rem"}}>
                    
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <div className="" style={{paddingTop:'10px', paddingBottom:'10px'}}>
                                    <h1 className="display-4 text-center">MIDDLEWARE</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div align="center">
                            <button id="btnIniciar"
                                    style={{
                                            opacity:.1,
                                            border: '1px solid gray',
                                            width:200, height:200,
                                            color:'lightgreen', 
                                            fontSize: '6em', 
                                            borderRadius:100, 
                                            backgroundColor:'white',
                                            }}
                                    value="iniciar" 
                                    onClick={this.start}>
                                    <i className="fas fa-play"></i>
                            </button>
                                    &nbsp;&nbsp;
                            <button id="btnDetener"
                                    style={{opacity:.1,border:'1px solid gray', width:200, height:200, color:'red', fontSize:'6em', borderRadius:100, backgroundColor:'white'}}
                                    value="detener" onClick={this.stop}><i className="fas fa-stop"></i></button>
                    </div>

                    <div align="center" style={{margin: "1rem"}}>
                        <DataTables headers={headers} view={"middleware"} data={data} search={this.callDocumentsListService}/>
                    </div>
                </div>
                
            </div>
        );
    }
}


const mapStateToProps = store => {
    return {notificationReducer: store.NotificationReducer};
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value})
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MiddlewareView);